module.exports = __webpack_public_path__ + "static/media/carousel5.75259d30.jpeg";